const styles = (theme) => ({
    root: {},
    scrollContainer: {
        height: '100vh',
        overflowY: 'auto',
    },
});

export default styles;
